module.exports = __webpack_public_path__ + "static/logo_tic_warm-ff2cbab1780712ae65350a72534d3e13.png";